<template>
    <form
        autocomplete="off"
        @submit.prevent="submitForm"
    >
        <BaseFormField>
            <BaseInput
                v-model="name"
                type="text"
                name="firstName"
                required
                :label="$t('name')"
                :novalidate="false"
            />
        </BaseFormField>

        <BaseFormField>
            <BaseInput
                v-model="email"
                type="email"
                name="email"
                :label="$t('email')"
                required
                :novalidate="false"
            />
        </BaseFormField>

        <BaseFormField>
            <BaseInput
                v-model="phone"
                type="text"
                name="phone"
                :label="$t('phone')"
                required
                :novalidate="false"
            />
        </BaseFormField>

        <BaseFormField>
            <BaseInput
                v-model="message"
                type="text"
                name="message"
                :label="$t('message')"
                required
                :novalidate="false"
            />
        </BaseFormField>

        <BaseFormField class="newsletter-form__action">
            <BaseButton
                class="base-button--tertiary"
                type="submit"
                :disabled="submitted || error"
            >
                <template #default>
                    <template v-if="submitted">
                        {{ $t('your-message-has-been-sent') }}
                    </template>
                    <template v-else-if="error">
                        {{ $t('error') }}
                    </template>
                    <template v-else>
                        {{ $t('send') }}
                    </template>

                    <BaseIcon
                        v-show="submitted"
                        icon="check"
                    />
                </template>
            </BaseButton>
        </BaseFormField>
    </form>
</template>

<script setup>
import { useGtm } from '@gtm-support/vue-gtm';

const email = ref(null);
const name = ref(null);
const phone = ref(null);
const message = ref(null);

onMounted(() => {
    email.value = null;
    name.value = null;
    phone.value = null;
    message.value = null;
});

const submitted = ref(false);
const error = ref(false);

async function submitForm() {
    const { status } = await useFetch('/api/contact', {
        query: {
            email: email.value || null,
            name: name.value || null,
            phone: phone.value || null,
            message: message.value || null,
            uri: window.location.href
        }
    });

    if (status && status.value === 'success') {
        submitted.value = true;
        error.value = false;

        const gtm = useGtm();
        gtm.trackEvent({
            /* eslint-disable camelcase */
            event: 'contact_form_submit',
            /* eslint-enable camelcase */
        });
    } else {
        submitted.value = false;
        error.value = true;
    }
}

watchEffect(() => {
    email.value;
    name.value;
    phone.value;
    message.value;

    submitted.value = false;
    error.value = false;
});
</script>
